import PropTypes from 'prop-types';
import { VIEW_DATE_WITH_TIME_FORMAT } from 'utils/constants/date';
import { formatDate } from 'utils/date';

import useTrls from 'hooks/translation/useTrls';

import Table from 'components/Table';

import { Refund } from 'components/Admin/InvoiceDetail/Invoice/InvoiceBody/Refund/Refund';
import Amounts from 'components/Admin/Invoices/InvoicesTable/Invoice/Amounts';
import PayerType from 'components/Admin/Invoices/InvoicesTable/Invoice/Payer/PayerType';
import Requisites from 'components/Admin/Invoices/InvoicesTable/Invoice/Requisites';
import { User } from 'components/Admin/Invoices/InvoicesTable/Invoice/User';
import TableBody from 'components/Table/TableBody';
import TableCell, { TableCellKind } from 'components/Table/TableCell';
import TableRow from 'components/Table/TableRow';

import 'components/Admin/InvoiceDetail/Invoice/InvoiceBody/InvoiceBody.less';

const InvoiceBody = ({ invoice }) => {
    const trl = useTrls();

    return (
        <Table fullWidth withStripes bordered>
            <TableBody>
                <TableRow>
                    <TableCell kind={TableCellKind.Title}>
                        {trl('admin.Invoices.InvoicesDetail.Invoice.Body.date')}
                    </TableCell>
                    <TableCell>{formatDate(invoice.createdAt, VIEW_DATE_WITH_TIME_FORMAT)}</TableCell>
                </TableRow>
                <TableRow>
                    <TableCell kind={TableCellKind.Title}>
                        {trl('admin.Invoices.InvoicesDetail.Invoice.Body.sum')}
                    </TableCell>
                    <TableCell>
                        <div className="invoice-amounts">
                            <Amounts {...invoice} />
                        </div>
                        <Refund {...invoice} />
                    </TableCell>
                </TableRow>
                <TableRow>
                    <TableCell kind={TableCellKind.Title}>
                        {trl('admin.Invoices.InvoicesDetail.Invoice.Body.requisites')}
                    </TableCell>
                    <TableCell>
                        <PayerType {...invoice} />
                        <Requisites {...invoice} />
                    </TableCell>
                </TableRow>
                <TableRow>
                    <TableCell>{trl('admin.Invoices.InvoicesDetail.Invoice.Body.user')}</TableCell>
                    <TableCell>
                        <User {...invoice} />
                    </TableCell>
                </TableRow>
            </TableBody>
        </Table>
    );
};

InvoiceBody.propTypes = {
    invoice: PropTypes.shape({
        id: PropTypes.number,
        createdAt: PropTypes.string,
        amount: PropTypes.number,
    }),
};

export default InvoiceBody;
